export const COMMUNITY = "communityIds";
export const ZONE = "zoneIds";
export const BLOCK = "blockIds";
export const OCCUPANCY = "occupancy";
export const SEARCH = "search";
export const OUTSTANDING_DUES = "outstandingDuesOnly";
export const STATUS = "status";

export const OWNER = "OWNER";
export const TENANT = "TENANT";
export const LANDLORD = "LANDLORD";
export const PROPERTY_MANAGER = "PROPERTY_MANAGER";

export const occupancyOptions = [
  { label: "Owner", value: OWNER },
  { label: "Tenant", value: TENANT },
  { label: "Landlord", value: LANDLORD },
  { label: "Property Manager", value: PROPERTY_MANAGER },
];

export const tabs = [
  { label: "All", value: "all"},
  { label: "Active", value: "active"},
  { label: "Inactive", value: "inactive"},
]